import { datadogRum } from '@datadog/browser-rum'

let initialized = false

const env = process.env.REACT_APP_ENVIRONMENT || 'unknown'
const service = process.env.REACT_APP_PACKAGENAME || 'unknown-service'
const version = process.env.REACT_APP_VERSION || '0.0.0'

const applicationId = '23c02149-2358-4220-8f33-00bbd7a25837'
const clientToken = 'pub731220440efe209f8ba43f63acbc979b'

export const initDatadogRum = () => {
	if (initialized) {
		return
	}
	datadogRum.init({
		applicationId,
		clientToken,
		site: 'datadoghq.eu',
		service,
		env,
		version,
		trackUserInteractions: true,
		trackResources: true,
		trackLongTasks: true,
		defaultPrivacyLevel: 'mask-user-input'
	})
	initialized = true
}

export const setDatadogRumUser = (user) => {
	if (!initialized || !user) {
		return
	}
	datadogRum.setUser({
		id: user.id,
		name: user.userName
	})
}

export const addDatadogRumAction = (name, data) => {
	if (!initialized) {
		return
	}
	datadogRum.addAction(name, data)
}

export const addDatadogRumError = (error, context) => {
	if (!initialized) {
		return
	}
	let safeContext = context
	if (
		context &&
		typeof context === 'object' &&
		'response' in context &&
		context.response instanceof Response
	) {
		const { response } = context
		safeContext = {
			...context,
			response: {
				status: response.status,
				statusText: response.statusText || '',
				url: response.url,
				ok: response.ok
			}
		}
	}
	datadogRum.addError(error, safeContext)
}
